import { Box, CircularProgress } from '@mui/material';

import { FProgressBar } from '../../../../../../components/base';
import { useQuestionnaireFormik } from '../../../../common/hooks';
import { onboardingQuestionnaireActions } from '../../../../../../store';
import { useOnboardingQuestionnaireLoading } from '../../../hooks';
import { ONBOARDING_TAB_IDS } from '../../../constants';
import {
  AssessmentsDiagnosesSection,
  CurrentReferralSection,
  DiagnosisReportSection,
} from './components';
import {
  useReferralDocuments,
  useReferralInitialValues,
  useSaveReferralFieldOnBlur,
  useUpdateReferralInfoLoading,
} from './hooks';
import { REFERRAL_FORM_BOX_SX } from './styles';
import { REFERRAL_FORM_SCHEMA } from './validationSchema';

export default function ReferralForm() {
  const initialValues = useReferralInitialValues();
  const isLoading = useOnboardingQuestionnaireLoading();
  const isUpdating = useUpdateReferralInfoLoading();
  const {
    documents,
    uploadDocument,
    deleteDocument,
    uploadDocumentLoading,
    deleteDocumentLoading,
  } = useReferralDocuments();
  const formik = useQuestionnaireFormik({
    tabId: ONBOARDING_TAB_IDS.REFERRAL,
    initialValues,
    validationSchema: REFERRAL_FORM_SCHEMA,
    hasNonFormikSavedValues: documents.length > 0,
    updateTabStatus: onboardingQuestionnaireActions.updateOnboardingTabStatus,
  });
  const saveFieldOnBlur = useSaveReferralFieldOnBlur(formik, initialValues);

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit} sx={REFERRAL_FORM_BOX_SX}>
      {isUpdating || uploadDocumentLoading || deleteDocumentLoading ? <FProgressBar /> : null}
      {isLoading ? (
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'rgba(255, 255, 255, 0.65)',
            display: 'flex',
            inset: 0,
            justifyContent: 'center',
            position: 'absolute',
            zIndex: 1,
          }}
        >
          <CircularProgress size={32} />
        </Box>
      ) : null}

      <Box>
        <CurrentReferralSection
          disabled={isLoading}
          formik={formik}
          saveFieldOnBlur={saveFieldOnBlur}
        >
          <AssessmentsDiagnosesSection
            disabled={isLoading}
            formik={formik}
            saveFieldOnBlur={saveFieldOnBlur}
          />
        </CurrentReferralSection>
      </Box>
      <Box>
        <DiagnosisReportSection
          deleteDocument={deleteDocument}
          disabled={isLoading}
          documents={documents}
          uploadDocument={uploadDocument}
        />
      </Box>
    </Box>
  );
}
